import React, { useEffect, useState} from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import QRCode from 'qrcode.react';
import { v4 as uuidv4 } from 'uuid';
import '../styles/QRPage.css';

const QRPage = () => {
  const navigate = useNavigate();

  return (
    <div className="qr-container">
      
    </div>
  );
};

export default QRPage;
